import { Submission } from '@repo/api/open-calls/graphql';
import type { CandidateInfoAboutConfig } from '@repo/ui/components/custom/candidate/info/about/component';
import type { NavigationFilterDefinition } from '@repo/ui/helpers/navigation-filter-definitions';

export const OPEN_CALL_TYPE_IDS = {
  OpenCasting: 'open-casting',
  AmericanStyle: 'american-style',
  Dogue: 'dogue',
} as const;

export type OpenCallTypeId =
  (typeof OPEN_CALL_TYPE_IDS)[keyof typeof OPEN_CALL_TYPE_IDS];

export type DogueFormDetails = {
  dogDetails?: {
    bio?: string;
    name?: string;
  };
};

export type TypedFormDetails = DogueFormDetails & Record<string, unknown>;

export type SubmissionWithTypedPayload = Submission & {
  data: Submission['data'] & {
    formDetails?: null | TypedFormDetails;
    typeId?: null | OpenCallTypeId | string;
  };
};

export type CandidateCardDisplay = {
  title: string;
  subtitle?: string;
};

export type CandidateListConfig = {
  compact: boolean;
};

export type CandidateDetailsConfig = {
  about?: CandidateInfoAboutConfig;
  showContact: boolean;
  showBio: boolean;
  showAttributes: boolean;
  parseBioAsQa: boolean;
};

export type FilterDisplayConfig = {
  enabled: boolean;
  definitions: NavigationFilterDefinition[];
};

export type BulkActionsConfig = {
  contactExport: boolean;
  copilotExport: boolean;
  dismiss: boolean;
  moveStage: boolean;
};

export type OpenCallTypeUiConfig = {
  bulkActions: BulkActionsConfig;
  candidateCard: {
    getDisplay: (candidate: SubmissionWithTypedPayload) => CandidateCardDisplay;
  };
  candidateDetails: CandidateDetailsConfig;
  candidateList: CandidateListConfig;
  filters: FilterDisplayConfig;
  typeId: OpenCallTypeId;
};
